import React, { useState, useEffect } from 'react'
import { DropdownContainer, DropdownHeader, DropdownList, DropdownItem, StatusIndicator, CloseButton, CredentialsModal } from './styles'
import { Pagination } from 'antd'
import authRequest from 'utils/authRequest'

const CardDropdown = ({ type, activeCount, onClose }) => {
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState({
    total: 0,
    page: 0,
    limit: 10,
    totalPages: 0
  })

  useEffect(() => {
    if (type) {
      fetchActiveItems(0)
    }
  }, [type])

  const fetchActiveItems = async (page = 0) => {
    setLoading(true)
    try {
      let response
      
      switch (type) {
        case 'corporate':
          response = await authRequest.get(`/dashboard/users?pageLimit=10&pageNo=${page}&type=corporate`)
          break
        case 'institute':
          response = await authRequest.get(`/dashboard/users?pageLimit=10&pageNo=${page}&type=institute`)
          break
        case 'student':
          response = await authRequest.get(`/dashboard/users?pageLimit=10&pageNo=${page}&type=student`)
          break
        case 'admin':
          response = await authRequest.get(`/dashboard/users?pageLimit=10&pageNo=${page}&type=internal`)
          break
        default:
          response = { data: { data: [] } }
      }

      // Transform API response to match expected format
      let apiData = []
      
      // All endpoints now use /dashboard/users with users array
      apiData = response?.data?.data?.users || []
      
      // Update pagination state from API response
      const paginationData = response?.data?.data?.pagination || {
        total: apiData.length,
        page: page,
        limit: 10,
        totalPages: Math.max(1, Math.ceil(apiData.length / 10))
      }
      console.log('Pagination data:', paginationData) // Debug log
      setPagination(paginationData)
      
      const transformedItems = apiData.map((item, index) => ({
        id: item.id || item._id || index + 1,
        name: `${item.first_name || ''} ${item.last_name || ''}`.trim() || item.name || item.corporateName || item.institute_name || `Unknown ${type}`,
        institute_name: item.institute_name, // Preserve institute_name field
        corporate_name: item.corporate_name, // Preserve corporate_name field
        lastActive: item.last_login_date 
          ? new Date(item.last_login_date).toLocaleString() 
          : item.updatedUp 
            ? new Date(item.updatedUp).toLocaleString()
            : 'Never',
        status: (item.isActive === 'Y' || item.is_active) ? 'Active' : 'Inactive',
        location: item.location || item.city || item.address || 'Unknown'
      }))
      
      setItems(transformedItems)
    } catch (error) {
      console.error('Error fetching active items:', error)
      // Set empty array on error to prevent UI issues
      setItems([])
    } finally {
      setLoading(false)
    }
  }

  const handlePageChange = (newPage) => {
    if (newPage >= 0 && newPage < pagination.totalPages) {
      fetchActiveItems(newPage)
    }
  }

  const getHeaderTitle = () => {
    if (type === 'corporate') return 'Corporate users'
    if (type === 'institute') return 'Institute users'
    if (type === 'student') return 'Students'
    if (type === 'admin') return 'Admin users'
    return 'Items'
  }

  return (
    <>
      <DropdownContainer>
        <DropdownHeader>
          <span>Online {getHeaderTitle()} ({activeCount})</span>
          <CloseButton onClick={onClose}>×</CloseButton>
        </DropdownHeader>
        {loading ? (
          <div style={{ padding: '40px', textAlign: 'center', fontSize: '16px' }}>Loading...</div>
        ) : activeCount === 0 ? (
          <div style={{ padding: '40px', textAlign: 'center', fontSize: '16px', color: '#8c8c8c' }}>
            {type === 'corporate' && 'There is no corporate online'}
            {type === 'institute' && 'There is no user online'}
            {type === 'student' && 'There is no student online'}
            {type === 'admin' && 'There is no admin user online'}
          </div>
        ) : (
          <DropdownList>
            {items.map(item => (
              <DropdownItem key={item.id}>
                <div>
                  <div style={{ fontWeight: '600', marginBottom: '8px', fontSize: '16px' }}>
                    {item.name}
                    {type === 'institute' && item.institute_name && (
                      <span style={{ fontWeight: '400', fontSize: '14px', color: '#666', marginLeft: '4px' }}>
                        - {item.institute_name}, {item.location}
                      </span>
                    )}
                    {type === 'student' && item.institute_name && (
                      <span style={{ fontWeight: '400', fontSize: '14px', color: '#666', marginLeft: '4px' }}>
                        - {item.institute_name}, {item.location}
                      </span>
                    )}
                    {type === 'corporate' && item.corporate_name && (
                      <span style={{ fontWeight: '400', fontSize: '14px', color: '#666', marginLeft: '4px' }}>
                        - {item.corporate_name}, {item.location}
                      </span>
                    )}
                    {type === 'admin' && (
                      <span style={{ fontWeight: '400', fontSize: '14px', color: '#666', marginLeft: '4px' }}>
                        - {item.role_type || "Admin"}
                      </span>
                    )}
                  </div>
                  <div style={{ fontSize: '14px', color: '#8c8c8c' }}>
                    Last active: {item.lastActive}
                  </div>
                </div>
                <StatusIndicator status={item.status} />
              </DropdownItem>
            ))}
          </DropdownList>
        )}
        {items.length > 0 && (
          <div style={{ padding: '16px 24px', background: '#fefefeff', display: 'flex', justifyContent: 'center' }}>
            <Pagination
              current={pagination.page + 1}
              total={pagination.total}
              pageSize={pagination.limit}
              showSizeChanger={false}
              showQuickJumper={false}
              onChange={(page) => handlePageChange(page - 1)}
              disabled={loading}
              size="small"
            />
          </div>
        )}
      </DropdownContainer>
    </>
  )
}

export default CardDropdown
